import cn from 'classnames'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './CategorySubTitleStandard.module.scss'

interface IProps {
  isShowQuotas?: boolean
  isShowActuals?: boolean
  isShowSubTitles?: boolean
  isEditRow?: boolean
}

export const CategorySubTitleStandard = ({
  isShowQuotas,
  isShowActuals,
  isShowSubTitles,
  isEditRow,
}: IProps) => {
  return (
    <div className={styles.root}>
      {!!isShowSubTitles && (
        <div className={styles.subTitles}>
          {!!isShowQuotas && (
            <div className={styles.quotaColor}>
              <Translation text="jbp-planning-quota" />
            </div>
          )}
          {!!isShowActuals && (
            <div className={styles.actualsColor}>
              <Translation text="jbp-planning-actuals" />
            </div>
          )}
          <div className={cn(styles.targetsColor, { [styles.editRow]: isEditRow })}>
            <Translation text="jbp-planning-targets" />
          </div>
        </div>
      )}
    </div>
  )
}
